<div class="empathy-search-skeleton">
  <div class="empathy-search-skeleton__search"></div>
  <div class="empathy-search-skeleton__button"></div>
</div>
